// extracted by mini-css-extract-plugin
export default {"radioList":"Health_radioList__UjhFc","radioOption":"Health_radioOption__zeWXS","buttonFooter":"Health_buttonFooter__8M2aR","buttonFooterFixed":"Health_buttonFooterFixed__007bp"};